// ------------------------------------------------------------------
// EDIT ME: add/remove nav items here. Add a "submenu" array to any
// item to turn it into a dropdown automatically (desktop + mobile).
// ------------------------------------------------------------------
const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Tentang", href: "#about" },
  { label: "Cara Kerja", href: "#features" },
  {
    label: "Unit Bisnis",
    href: "#business",
  },
  // { label: "Kenapa WinRevo", href: "#why-us" },
  // {
  //   label: "Resources",
  //   href: "#",
  //   submenu: [
  //     { label: "Blog", href: "#" },
  //     { label: "Documentation", href: "#" },
  //     { label: "Support", href: "#" },
  //   ],
  // },
  // { label: "Kontak Kami", href: "#cta" },
];

export default navLinks;
